import React from "react";

import SecondaryButton from "../../../widgets/Buttons/SecondaryButton";
import ErrorSnackbar from "../../../widgets/Snackbar/ErrorSnackbar";
import styles from "../../../components/StudentDetails/StudentDetails.module.scss";

const StudentNotFoundState = ({ errorMessage, onBack }) => (
  <div className={styles.wrapper}>
    <div className={styles.headerBox}>
      <SecondaryButton
        onClick={onBack}
        className={styles.headerButton}
      >
        Go Back
      </SecondaryButton>
    </div>
    <p className={styles.noData}>No student data found.</p>
    <ErrorSnackbar
      open={!!errorMessage}
      message={errorMessage}
      onClose={() => {}}
    />
  </div>
);

export default StudentNotFoundState;
